/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {inject, InjectionToken} from "@angular/core";
import {UsersService} from "./users.service";

export const USERS_SAVE_SERVICE_TOKEN = new InjectionToken('users_save_service_token', {
  factory: () => inject(UsersService)
});
